module.exports = __webpack_public_path__ + "static/img/ums-admin-active.dab7dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/ums-admin-active.png
// module id = 6rXd
// module chunks = 26